import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/Login.vue'
import Home from '@/views/Home.vue'
import Register from '@/views/Register.vue'
import { getToken } from '@/cookie';

import Configure from '@/views/components/Configure.vue';

Vue.use(VueRouter);

let routes = [
    {
        path: '/',
        component: Home,
        name: "index",
        meta: {
            title: '首页',
        }
    },
    {
        path: '/login',
        component: Login,
        name: 'login',
        meta: {
            title: '云票平台',
        },
        hidden: true
    },
    {
        path: '/register',
        component: Register,
        name: 'register',
        meta: {
            title: '注册',
        },
        hidden: true
    },
    {
        path: '/configure',
        component: Configure,
        name: 'configure',
        meta: {
            title: '配置',
        },
        hidden: true
    }
];

const router = new VueRouter({
    routes
});

router.beforeEach((to,from,next) => {
    if(to.meta.title){
       document.title = to.meta.title;
    } 
    if(to.name == 'login' || to.name == 'register'){
       next();
    } else {
        let token = getToken();
        if(token != null && token != ''){
           next(); 
        } else {
           next({path:'/login'});
        }
    }
 });

export default router;


// WEBPACK FOOTER //
// ./src/routes.js